import React from "react";
import { useTranslation } from "react-i18next";

const BAND_CLASS = {
  critical: "bg-rose-600 text-white border-rose-700",
  high: "bg-orange-500 text-white border-orange-600",
  medium: "bg-amber-400 text-zinc-950 border-amber-500",
  low: "bg-emerald-500 text-white border-emerald-600",
};

export function bandFor(priority) {
  const p = Number(priority || 0);
  if (p >= 9) return "critical";
  if (p >= 7) return "high";
  if (p >= 4) return "medium";
  return "low";
}

/**
 * Guardian priority badge — round /10 chip with semantic color band.
 * Color thresholds match the backend `alm.priority.guardian_priority_band`.
 *
 * Sizes:
 *   - "lg": 36px circle for dashboard widgets / drawer
 *   - "md": 28px (default)
 *   - "sm": 22px inline rows
 */
export default function GuardianPriorityBadge({ priority, size = "md", showLabel = false }) {
  const { t } = useTranslation("alerts");
  const p = Math.max(1, Math.min(10, Number(priority || 1)));
  const band = bandFor(p);
  const cls = BAND_CLASS[band];
  const sizeCls = size === "lg" ? "w-9 h-9 text-base" : size === "sm" ? "w-[22px] h-[22px] text-[10px]" : "w-7 h-7 text-xs";
  return (
    <span className="inline-flex items-center gap-1.5" data-testid={`guardian-priority-${p}`}>
      <span
        title={t("guardian_priority.tooltip", { priority: p })}
        className={`inline-flex items-center justify-center rounded-full font-display font-bold tabular-nums border ${cls} ${sizeCls}`}
      >
        {p}
      </span>
      {showLabel && (
        <span className="text-[11px] uppercase tracking-wider text-zinc-500">
          {t("guardian_priority.label")}
        </span>
      )}
    </span>
  );
}
